import sendNetworkReq from '@/utils/sendNetworkReq';

export const GET_ALL_KNOWN_BRANDS = 'GET_ALL_KNOWN_BRANDS';

export const getAllKnownBrands = () => {
	return async (dispatch) => {
		const { brands } = await sendNetworkReq({
			method: 'GET',
			url: 'brands/known',
			auth: false,
		});
		dispatch({
			type: GET_ALL_KNOWN_BRANDS,
			payload: brands || [],
		});
	};
};
